/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Gender:<br />
 * @export
 */
export const TravelineBookingGuestSexKindDto = {
    Male: 'Male',
    Female: 'Female'
} as const;
export type TravelineBookingGuestSexKindDto = typeof TravelineBookingGuestSexKindDto[keyof typeof TravelineBookingGuestSexKindDto];


export function instanceOfTravelineBookingGuestSexKindDto(value: any): boolean {
    for (const key in TravelineBookingGuestSexKindDto) {
        if (Object.prototype.hasOwnProperty.call(TravelineBookingGuestSexKindDto, key)) {
            if (TravelineBookingGuestSexKindDto[key as keyof typeof TravelineBookingGuestSexKindDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelineBookingGuestSexKindDtoFromJSON(json: any): TravelineBookingGuestSexKindDto {
    return TravelineBookingGuestSexKindDtoFromJSONTyped(json, false);
}

export function TravelineBookingGuestSexKindDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingGuestSexKindDto {
    return json as TravelineBookingGuestSexKindDto;
}

export function TravelineBookingGuestSexKindDtoToJSON(value?: TravelineBookingGuestSexKindDto | null): any {
    return value as any;
}

export function TravelineBookingGuestSexKindDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelineBookingGuestSexKindDto {
    return value as TravelineBookingGuestSexKindDto;
}

